import React, { useState, useEffect } from "react";
import styles from "./CookieBanner.module.css";
import {
  openCookieSettings,
  saveConsentToLocalStorage,
  applyCookieSettings,
  getConsentFromLocalStorage,
  updateGoogleConsent
} from "../../../components/utils/cookieEvents.jsx";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsentFromLocalStorage();
    if (!consent) {
      setVisible(true);
      return;
    }
    updateGoogleConsent(consent);
  }, []);

  useEffect(() => {
    const hideBanner = () => setVisible(false);
    window.addEventListener("cookieConsentSaved", hideBanner);

    return () => window.removeEventListener("cookieConsentSaved", hideBanner);
  }, []);

  const handleAccept = () => {
    const consent = {
      necessary: true,
      analytics: true,
      marketing: true,
      decision: "accept"
    };
    saveConsentToLocalStorage(consent);
    applyCookieSettings(consent);
    updateGoogleConsent(consent);
    localStorage.setItem("cookieStatus", JSON.stringify(consent));
    setVisible(false);
  };

  const handleReject = () => {
    const consent = {
      necessary: true,
      analytics: false,
      marketing: false,
      decision: "reject"
    };

    saveConsentToLocalStorage(consent);
    applyCookieSettings(consent);
    updateGoogleConsent(consent);
    localStorage.setItem("cookieStatus", JSON.stringify(consent));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.cookieBanner}>
      <div className={styles.cookieContent}>
        <Cookie className={styles.icon} fill="currentColor" />
        <p>
          Używamy plików cookies - aby poprawić działanie strony i analizwoać
          ruch. Możesz zaakceptować wszystkie ciasteczka, odrzucić je lub wybrać
          szczegółowe ustawienia..
        </p>

        <div className={styles.cookieButtons}>
          <button
            className={`${styles.cookieBtn} ${styles.accept}`}
            onClick={handleAccept}
          >
            Akceptuję
          </button>
          <button
            className={`${styles.cookieBtn} ${styles.reject}`}
            onClick={handleReject}
          >
            Odrzucam
          </button>
          <button
            className={`${styles.cookieBtn} ${styles.settings}`}
            onClick={openCookieSettings}
          >
            Ustawienia
          </button>
        </div>
      </div>
    </div>
  );
}
